import {
  type TrustCheckViewModel,
  useTrustChecksViewModel,
} from "@/hooks/matter-view-models/use-trust-checks-view-model";
import { retrieveMatterQueryOptions } from "@/lib/data/react-query/matters/matter";
import type { MatterExpense } from "@/lib/types";
import { getMatterContactConnectionLinkedId } from "@/lib/utils/matters/matter-contact-connection-party-roles";
import { useSuspenseQuery } from "@tanstack/react-query";
import dayjs from "dayjs";

export type ExpenseViewModel = MatterExpense & {
  trustChecks: TrustCheckViewModel[];
};

export const useExpensesViewModel = (matterId: string) => {
  const { data: matterData } = useSuspenseQuery(
    retrieveMatterQueryOptions(matterId),
  );
  const matter = matterData.data;
  const trustChecksViewModel = useTrustChecksViewModel(matterId);

  return matter.expenses
    .map((expense) => {
      const trustChecks = trustChecksViewModel.filter((trustCheck) =>
        trustCheck.connections.some(
          (connection) =>
            getMatterContactConnectionLinkedId(connection, "expenseId") ===
            expense.id,
        ),
      );

      return {
        ...expense,
        trustChecks,
      } as ExpenseViewModel;
    })
    .sort((a, b) => {
      if (a.dateCreated === b.dateCreated) {
        return 0;
      }
      return dayjs(a.dateCreated).isAfter(dayjs(b.dateCreated)) ? -1 : 1;
    });
};
